// extracted by mini-css-extract-plugin
module.exports = {"fundo":"Machine_fundo__1NCw-","listaMachine":"Machine_listaMachine__3W47z","tudo":"Machine_tudo__3DeUu"};